import {Service} from '@/request/http.js'

// 获取用户信息
export function getUserInfo (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}
// 设置cookie
export function setUserCookie (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}
// 修改用户信息
export function modifyUserInfo (data) {
  return Service({
    url: '/api/modifyUserInfo',
    method: 'post',
    params: data
  })
}
// 用户支付方式
export function getPaymentList (data) {
  return Service({
    url: '/api/getPaymentList',
    method: 'post',
    params: data
  })
}
// 删除支付方式
export function delPayment (data) {
  return Service({
    url: '/api/delPayment',
    method: 'post',
    params: data
  })
}
// 发送邮箱验证
export function sendVerifyEmail (data) {
  return Service({
    url: '/api/sendVerifyEmail',
    method: 'post',
    params: data
  })
}
// 用户验证
export function doVerifyUser (data) {
  return Service({
    url: '/api/doVerifyUser',
    method: 'post',
    params: data
  })
}

// 用户验证
export function getCustomerInfo (data) {
  return Service({
    url: '/api/getCustomerInfo',
    method: 'post',
    params: data
  })
}
// 解绑微信
export function unbindEmail (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

// 绑定邮箱
export function bindEmail (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

// 检验邮箱
export function checkEmail (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

// 解除微信绑定
export function UnBindWechat (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

// 微信授权绑定
export function weiXinBind (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

export function sendMobileCode (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

export function bindMobile (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}

export function orderCancel (data) {
  return Service({
    url: '/api/userInfo',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/user.js